<template>
  <div class="url">
    <p class="desc" v-html="$t('journey.capture.url.description')"></p>
    <div class="set-url">
      <div class="url-type">
        <label>
          <input type="radio"
                 @input="$emit('onSelectUrlTypeAction', 'default')"
                 :value="'default'"
                 v-model="urlType">
          <i class="icon icon--radio-off"></i>
          {{ $t('journey.capture.url.defaultUrl') }}
        </label>
        <label>
          <input type="radio"
                 @input="$emit('onSelectUrlTypeAction', 'custom')"
                 :value="'custom'"
                 v-model="urlType">
          <i class="icon icon--radio-off"></i>
          {{ $t('journey.capture.url.customUrl') }}
        </label>
      </div>
      <ui-input-text :type="'text'"
                     :id="'captureUrl'"
                     :name="'captureUrl'"
                     :placeholder="''"
                     :modelError="modelError.captureUrl"
                     :modelValue="model.captureUrl"
                     :disabled="urlType === 'default'"
                     @onFocus="modelError.captureUrl = ''"
                     @input="model.captureUrl = $event"></ui-input-text>
    </div>
    <!-- <div class="buttons">
      <ui-button :primary2="true"
                 :disabled="model.captureUrl.length < 1"
                 @click="$emit('onCaptureAction')">{{ $t('common.confirm') }}</ui-button>
    </div> -->
  </div>
</template>
<script>
import UiInputText from '@/components/ui/UiInputText'

export default {
  components: {
    UiInputText
  },
  props: [
    'urlType',
    'model',
    'modelError',
    'onCaptureAction',
    'onSelectUrlTypeAction'
  ],
  methods: {

  }
}
</script>
<style lang="scss" scoped>
.url {
  position: absolute;
  width: 100%;
  .desc {
    margin: 14px 5px;
    font-size: 14px;
    line-height: 1.57;
    color: #666666;
    height: 88px;
    text-align: center;
  }
  .set-url {
    text-align: center;
    margin: 58px 0;
    padding: 0 50px;
    border-top: dashed 1px #d7d7d7;
    label {
      font-size: 14px;
      line-height: 1.57;
      color: #666666;
      padding: 22px 15px 9px 15px;
      display: inline-block;
      cursor: pointer;
      .icon {
        vertical-align: middle;
        margin-top: -2px;
      }
    }
    .input--wrap.above-input {
      margin-top: 0;
    }
  }
  .buttons {
    padding-top: 46px;
    text-align: center;
    .ui-btn {
      min-width: 90px;
    }
  }
}
</style>
